import { render } from "./StockExpiryReport.vue?vue&type=template&id=a70fb678&ts=true"
import script from "./StockExpiryReport.vue?vue&type=script&lang=ts"
export * from "./StockExpiryReport.vue?vue&type=script&lang=ts"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__